import api_adm from "./api";
const endpoint = "WebsiteRestController";
const amiEndpoint = "volontariat/Ami";

export const RecrutementService = {
  async getListOffreCOnsultant(filtre) {
    try {
      const result = await api_adm.get(endpoint + "/list_association", {
        params: filtre,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getOffreExterneList(filtre) {
    try {
      const result = await api_adm.get(endpoint + "/offre_externe", {
        params: filtre,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getOffreVolontariatList(filtre) {
    try {
      const result = await api_adm.get(endpoint + "/offre_volontariat", {
        params: filtre,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  /**
   * Exporter en excel les reponses envoyés aux formulaires sur l'offre selectionnées
   * @param {*} filtre 
   * @returns 
   */
  async exportExcelReponseAuxFormulaireParOffre(filtre) {
    try {
      const result = await api_adm.get(amiEndpoint + "/offre_volontariat", {
        params: filtre,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getFilteredOffre(filtre) {
    try {
      const result = await api_adm.get(amiEndpoint + "/liste_offres_ami", {
        params: filtre,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
};
